import React from 'react';
import { SimpleForm, TextInput, BooleanInput, required } from 'react-admin';

/** Shared body for the vendor create and edit screens. */
const VendorForm = props => (
    <SimpleForm {...props} initialValues={{ status: true }}>
        <TextInput source="name" label="Vendor Name" validate={required()} />
        <TextInput source="code" label="Code" />
        <TextInput source="contact" label="Contact" />
        <TextInput source="phone" label="Phone" />
        <TextInput source="email" label="Email" />
        <TextInput source="address" label="Address" fullWidth />
        <BooleanInput source="status" label="Is Active?" />
    </SimpleForm>
);

export default VendorForm;
